export default {
  SET_LOADING(state, value) {
    state.loading = value
  },

  SET_ERROR(state, error) {
    state.error = error
  },
  SET_MESSAGE(state, message) {
    state.message = message
  },
  SET_USERS(state, data) {
    state.users = data.data
  },

  SET_USER(state, user) {
    state.user = user
  },
  SET_USER_DATA(state, user) {
    state.userMe = user
  },
  RESET_USER(state) {
    state.user = null
  },
  RESET_USER_DATA(state) {
    state.userMe = null
  },
  SET_FILTERS(state, filters) {
    state.filters = { ...state.filters, ...filters }
  },

  SET_PAGINATION(state, data) {
    state.pagination = {
      total: data.total,
      current_page: data.current_page,
      last_page: data.last_page
    }
  },

  ADD_USER(state, user) {
    state.users.unshift(user)
  },

  UPDATE_USER(state, updatedUser) {
    const index = state.users.findIndex(u => u.id === updatedUser.id)
    if (index !== -1) {
      state.users.splice(index, 1, updatedUser)
    }
  },

  DELETE_USER(state, id) {
    const index = state.users.findIndex(u => u.id === id)
    if (index !== -1) {
      state.users.splice(index, 1, { id , is_active: false })
    }
  },

  ACTIVATE_USER(state, id) {
    const index = state.users.findIndex(u => u.id === id)
    if (index !== -1) {
      state.users.splice(index, 1, { id , is_active: true })
    }
  },
}